import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  selector: 'ui-base-card',
  template: `
    <div
      class="{{
        'flex flex-wrap items-start gap-x-6 h-full bg-white shadow-md p-6 rounded-lg ' +
          class()
      }}"
      [class.flex-row]="!reverse()"
      [class.flex-row-reverse]="reverse()"
    >
      <ng-content select="[icon]"></ng-content>
      <div class="{{ 'flex flex-col ' + widthClasses() }}">
        <ng-content select="[content]"></ng-content>
      </div>
      <ng-content select="[footer]"></ng-content>
    </div>
  `,
})
export class BaseCardComponent {
  width = input<'fit' | 'full'>('fit');
  reverse = input<boolean>(false);
  class = input<string>();

  widthClasses = computed(() => this.width() === 'fit' ? 'w-fit sm:w-full lg:w-fit' : 'w-full')
}
